var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"nights-range-selector"},[_vm._t("label"),_vm._v(" "),_c(_setup.Counter,{attrs:{"min":1,"max":29},model:{value:(_setup.counterNights),callback:function ($$v) {_setup.counterNights=$$v},expression:"counterNights"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }